<template>
  <span @mousedown.prevent="mouseDown">{{ formattedTime }}</span>
</template>

<script>
import bus from "../bus.js"
import timeFormat from "../utils/time_format"

export default {
  props: ["mixID"],
  data() {
    return {
      duration: undefined,
      currentMix: undefined,
      currentTime: undefined,
      seekTime: undefined,
      inSeek: false,
      initialSeekX: undefined,
    }
  },
  methods: {
    calculateSeekPosition(ev) {
      const seekWidth = 400
      const delta = ev.pageX - this.initialSeekX
      const mixPercentageDelta = delta / (seekWidth / 2)
      const duration = this.duration
      const currentPosition = this.currentTime

      let newMixPosition = currentPosition + mixPercentageDelta * duration
      newMixPosition = Math.max(0, newMixPosition)
      newMixPosition = Math.min(duration, newMixPosition)
      return newMixPosition
    },
    mouseDown(ev) {
      if (this.currentTime == undefined) return

      this.initialSeekX = ev.pageX
      this.inSeek = true
      document.addEventListener("mousemove", this.mouseMove)
      document.addEventListener("mouseup", this.mouseUp)
    },
    mouseMove(ev) {
      this.seekTime = this.calculateSeekPosition(ev)
    },
    mouseUp(ev) {
      document.removeEventListener("mousemove", this.mouseMove)
      document.removeEventListener("mouseup", this.mouseUp)

      const newTime = this.calculateSeekPosition(ev)
      bus.emit("seek-to", newTime)
      this.currentTime = newTime // prevent display from flickering
      this.seekTime = undefined
    },
  },
  computed: {
    formattedTime() {
      if (!this.currentMix) return ""

      if (this.mixID && this.currentMix.id != this.mixID) return ""

      if (this.currentTime == undefined) return timeFormat(0)

      let displayTime = this.seekTime
      if ( displayTime == undefined )
        displayTime = this.currentTime

      return timeFormat(displayTime, 0)
    },
  },
  mounted() {
    bus.on("player-time-update", payload => {
      this.currentMix = payload.mix
      this.currentTime = payload.time
      this.duration = payload.duration
    })
  },
}
</script>
